export default "__VITE_ASSET__BfIkQ8QY__"